import * as React from 'react';
const SvgMegaphone = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M19.92 4.62c-.07-.16-.17-.3-.3-.4a1 1 0 0 0-.24-.14C19.2 4 18.96 4 18.5 4s-.7 0-.88.08c-.24.1-.44.3-.54.54-.08.18-.08.42-.08.88v13c0 .27 0 .47.02.62.01.11.03.19.06.27.1.25.3.44.54.54.18.08.42.08.88.08s.7 0 .88-.08c.13-.06.25-.14.35-.25.08-.09.14-.19.19-.3.06-.14.07-.31.08-.6V5.5c0-.3 0-.5-.02-.65a.8.8 0 0 0-.06-.23M16 6.07c-.38.22-.77.42-1.19.61-.65.3-1.32.56-2 .79s-1.35.42-2.02.56c-.66.15-1.3.25-1.9.32H6.2c-1.04 0-1.84.27-2.38.8S3 10.45 3 11.46v1.13c0 1.01.27 1.77.82 2.31.54.53 1.34.8 2.38.8h2.65a20.4 20.4 0 0 1 4 .89c.66.22 1.32.48 1.95.78.41.19.81.42 1.2.65zM9.52 16.82c-.24-.04-.49-.1-.73-.12H6.2c-.33 0-.64-.02-.93-.07l1.39 3.09c.2.44.44.76.71.95s.56.3.84.32c.29.02.55 0 .78-.08.35-.11.63-.33.82-.65s.24-.72.14-1.21l-.43-2.24z"
    />
  </svg>
);
export default SvgMegaphone;
